import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.4958 4.00345C20.7949 4.01509 21.1028 4.05863 21.3591 4.23392C21.718 4.47937 21.9508 4.87069 21.9949 5.30326C22.0263 5.61209 21.9176 5.90324 21.7849 6.17142C21.652 6.44002 21.451 6.7666 21.2078 7.16263L13.3611 19.939C13.0242 20.4875 12.7541 20.927 12.5222 21.2408C12.3014 21.5396 12.0392 21.8349 11.6873 21.939C11.217 22.078 10.7083 21.9745 10.3298 21.6626C10.0468 21.4293 9.9221 21.0552 9.83569 20.6939C9.74494 20.3144 9.66766 19.8042 9.57202 19.1675L8.65308 13.0464L15.7029 9.09915C15.9398 8.96631 16.024 8.66629 15.8914 8.42923C15.7586 8.19209 15.4586 8.10703 15.2214 8.23978L8.27515 12.1294C8.25462 12.1132 8.23227 12.0947 8.20679 12.0747L3.60522 8.47708C3.10912 8.08917 2.71088 7.77732 2.43042 7.51615C2.1625 7.26663 1.90257 6.97797 1.83765 6.62064C1.75068 6.14135 1.90641 5.64976 2.25268 5.30716C2.51092 5.05176 2.88909 4.9642 3.25171 4.91361C3.63115 4.86069 4.13581 4.83426 4.7644 4.8013L19.3503 4.03568C19.8143 4.01134 20.1965 3.99182 20.4958 4.00345Z"
      fill="#4F4F4F"
    />
  </svg>
);
export default SVGComponent;
